import styled from '@emotion/styled';

import { Path } from 'components/icons/styles';
import { InputRoot } from 'components/inputs/input/styles';

export const AccountSection = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 8,

  width: 290,
  // @ts-ignore
  [InputRoot]: {
    width: 290,
  },
}));

export const MerchantIdSection = styled(AccountSection)();
export const GroupAccountSection = styled(AccountSection)();
export const AccountOwnerSection = styled(AccountSection)();
export const FiatCurrencySection = styled(AccountSection)();

export const Label = styled.div((props) => ({
  fontSize: 13,
  lineHeight: '16px',
  fontWeight: 400,
  fontFamily: props.theme.fonts.primary,
}));

export const Optional = styled(Label)((props) => ({
  fontStyle: 'italic',
  color: props.theme.colors.inactive,
}));

export const Welcome = styled(Label)((props) => ({
  color: props.theme.colors.inactive,
}));

export const Adornment = styled.div((props) => ({
  fontSize: 13,
  lineHeight: '16px',
  fontFamily: props.theme.fonts.primary,
  fontWeight: 500,
  color: props.theme.colors.inactive,
  marginRight: 8,
  width: 16,
  height: 16,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  // @ts-ignore
  [Path]: {
    fill: props.theme.colors.inactive,
  },
}));

export const Row = styled.div((props) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 40,
}));
